import { DateRange } from "./date";
export class Orders{
    orderId: number;

}

export class OrdersSearch {
    createdDate: DateRange = DateRange.empty();
    type = 'mobile_no';
    id: number;
    appCode = '';
    productName='';
    displayName='';
    deliveryMethod;
    merchantId='';
    status:number;
    receiptNo='';
    number = '';
    userCartId:number;
    orderNumber:'';
    locationId: any;
    linkedProduct:any;
    disabled: boolean;
    isAvailable: boolean;
    orderStatus:any;
    merchantLocationid:any;
    orderCreatedFrom:any;
    pageIndex = 1;
    pageSize = 10;
    merchantOrderId ='';
    
}